/*!
 * FrontBox 1.3.0
 * Copyright Bartosz Piwek
 * https://github.com/BartoszPiwek/FrontBox
 */
import "./app/polyfill";

import { Browser } from "./bootstrap/browser";
import { Burger } from "./bootstrap/burger";
import { html } from "./bootstrap/elements";
import { Scroll } from "./bootstrap/scroll";
import { modalsInit } from "./modals/init";
import { SliderHomepage } from "./app/slider-homepage";
import { floatingInformationInit } from "./app/floating-information";
import { ExpandContent } from "./app/expand-content";
import { PDFReader } from "./app/pdf-reader";
import { videoPlayer } from "./app/video";
import { Sliders } from "./app/sliders";
import { StickyService } from "./service/sticky.service";
import { loginPage } from "./app/loginPage";

export const vh = require('vh-check')();
export const BrowserComponent = new Browser();
export const scroll = new Scroll();

window.onload = () => {

	new Burger({
		button: document.getElementById("burger-button"),
		container: document.getElementById("header"),
		overlay: document.getElementById("burger-overlay")
	});

	new StickyService({
		elements: document.querySelectorAll('.sticky')
	});

	new ExpandContent({
		elements: document.querySelectorAll('.navigation__link'),
	});

	floatingInformationInit();

	modalsInit();

	videoPlayer();

	loginPage();

	new SliderHomepage();
	new Sliders();

	/* PDF Reader Page */
	new PDFReader();

	/* Inform stylesheet to remove style fallback for JavaScript elements */
	html.classList.remove("isLoading");
	html.classList.remove("isJsDisabled");
};
